import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseCulturePortalComponent } from './case-culture-portal/case-culture-portal/case-culture-portal.component';
import { CaseCulturePortalHomeComponent } from './case-culture-portal/case-culture-portal-home/case-culture-portal-home.component';
import { CaseManagementPortalHomeComponent } from './case-management-portal/case-management-portal-home/case-management-portal-home.component';
import { CaseManagementPortalLoginComponent } from './case-management-portal/case-management-portal-login/case-management-portal-login.component';
import { CaseManagementPortalSettingsComponent } from './case-management-portal/case-management-portal-settings/case-management-portal-settings.component';
import { CaseManagementPortalComponent } from './case-management-portal/case-management-portal/case-management-portal.component';
import { CaseCulturePortalReportCaseComponent } from './case-culture-portal/case-culture-portal-report-case/case-culture-portal-report-case.component';
import { CaseCulturePortalCaseComponent } from './case-culture-portal/case-culture-portal-case/case-culture-portal-case.component';
import { CaseCulturePortalLoginComponent } from './case-culture-portal/case-culture-portal-login/case-culture-portal-login.component';
import { CaseManagementPortalCaseComponent } from './case-management-portal/case-management-portal-case/case-management-portal-case.component';
import { LandingPageComponent } from './home-page/landing-page/landing-page.component';

const routes: Routes = [
  // case culture portal routes
  {
    path: 'client',
    component: CaseCulturePortalComponent,
    children: [
      { path: '', component: CaseCulturePortalHomeComponent },
      { path: 'report', component: CaseCulturePortalReportCaseComponent },
      { path: 'case', component: CaseCulturePortalCaseComponent },
      { path: 'login', component: CaseCulturePortalLoginComponent },
      { path: '**', redirectTo: '', pathMatch: 'full' },
    ],
  },
  // case management portal routes
  {
    path: 'management',
    component: CaseManagementPortalComponent,
    children: [
      { path: '', component: CaseManagementPortalHomeComponent },
      { path: 'case', component: CaseManagementPortalCaseComponent },
      { path: 'settings', component: CaseManagementPortalSettingsComponent },
      { path: 'login', component: CaseManagementPortalLoginComponent },
      { path: '**', redirectTo: '', pathMatch: 'full' },
    ],
  },
  {
    path: '',
    component: LandingPageComponent,
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
